module.exports = __webpack_public_path__ + "img/img_skin_2.d6cadea3.png";